module.exports = __webpack_public_path__ + "img/user-13.a8479cb8.jpg";